const routes = [
  // 线下课
  {
    path: "/offline",
    name: "offline",
    meta: {
      title: '线下课',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/educational/courses.vue"),
  },
  // 一对一直播/一对多直播/大课直播
  {
    path: "/coursesLive",
    name: "coursesLive",
    meta: {
      title: '直播课',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/educational/courses.vue"),
  },
  // 智慧课堂
  {
    path: "/wisdom",
    name: "wisdom",
    meta: {
      title: '精品课程',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/educational/courses.vue"),
  },
  // 创建课程
  {
    path: "/offline/created",
    name: "offline/created",
    meta: {
      title: '创建课程',
      hasBack: true
    },
    component: () => import("../pages/educational/courses/created")
  },
  {
    path: "/coursesLive/created",
    name: "coursesLive/created",
    meta: {
      title: '创建课程',
      hasBack: true
    },
    component: () => import("../pages/educational/courses/created")
  },
  {
    path: "/wisdom/created",
    name: "wisdom/created",
    meta: {
      title: '创建课程',
      hasBack: true
    },
    component: () => import("../pages/educational/courses/created")
  },
];

export default routes;
